import React from 'react';

export default function MapControls({ onZoomIn, onZoomOut, onFit, canZoomIn = true, canZoomOut = true }) {
  return (
    <div style={{ position: 'absolute', right: 12, bottom: 120, display: 'flex', flexDirection: 'column', gap: 8, zIndex: 1200, pointerEvents: 'none' }} role="group" aria-label="Controles del mapa">
      <button
        type="button"
        aria-label="Alejar"
        disabled={!canZoomOut}
        onClick={onZoomOut}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onZoomOut?.()}
        style={{ width: 44, height: 44, borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--surface)', color: 'var(--text)', pointerEvents: 'auto', touchAction: 'manipulation' }}
      >
        −
      </button>
      <button
        type="button"
        aria-label="Acercar"
        disabled={!canZoomIn}
        onClick={onZoomIn}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onZoomIn?.()}
        style={{ width: 44, height: 44, borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--surface)', color: 'var(--text)', pointerEvents: 'auto', touchAction: 'manipulation' }}
      >
        +
      </button>
      <button
        type="button"
        aria-label="Encuadrar"
        onClick={onFit}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onFit?.()}
        style={{ width: 44, height: 44, borderRadius: 8, border: '1px solid var(--border-color)', background: 'var(--surface)', color: 'var(--text)', pointerEvents: 'auto', touchAction: 'manipulation' }}
      >
        ⤢
      </button>
    </div>
  );
}


